import { render, staticRenderFns } from "./scroll-table.vue?vue&type=template&id=ea2a5bb8&"
import script from "./scroll-table.vue?vue&type=script&lang=js&"
export * from "./scroll-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports